import { databaseMedia } from './../firebase/firebase-app-media';

export const listenToPicturesByIds = (ids = [], context = '') => {
  return (dispatch, getState) => {
    const loadedIds = Object.keys(getState().pictures);
    const idsToFetch = ids.filter(elem => !loadedIds.includes(elem));
    const p = idsToFetch.map(key => databaseMedia.ref('pictures').child(key).once('value'));
    Promise.all(p).then(values => {
      dispatch({
        type: 'RECEIVE_PICTURES',
        payload: values.reduce((res, current, i) => ({ ...res, [current.key]: current.val()}), {}),
        context
      });
      if (context === 'categories') {
        dispatch({
          type: 'SET_LOADING',
          p: { pictures: true }
        });
      }
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/pictures.js